import { useState } from 'react';
import { faqs } from '@/mocks/categories';

export default function FAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);

  return (
    <section className="relative bg-background-100 py-14 md:py-20">
      <div className="w-full px-4 md:px-6 lg:px-10">
        <div className="max-w-5xl mx-auto">
          <div className="bg-foreground-950 rounded-3xl p-8 md:p-12 lg:p-14 relative overflow-hidden">
            <div className="absolute top-0 right-0 text-9xl text-foreground-800/20 leading-none select-none">
              &ldquo;
            </div>

            <div className="relative z-10 flex flex-col lg:flex-row gap-8 lg:gap-12">
              <div className="lg:w-2/5">
                <div className="w-20 h-20 mb-6 rounded-2xl overflow-hidden">
                  <img
                    src="https://readdy.ai/api/search-image?query=Professional%20minimalist%20community%20avatar%20style%20portrait%2C%20warm%20cream%20background%2C%20clean%20modern%20aesthetic%2C%20editorial%20photography%2C%20soft%20lighting%2C%20friendly%20approachable%20atmosphere%2C%20simple%20composition&width=300&height=300&seq=faq-portrait-v3&orientation=squarish"
                    alt="AcBuy expert"
                    className="w-full h-full object-cover object-top"
                  />
                </div>
                <h2 className="text-2xl md:text-3xl font-bold text-background-50 mb-3">Frequently Asked Questions</h2>
                <p className="text-sm text-background-50/60 leading-relaxed mb-6">
                  Everything you need to know about the AcBuy Spreadsheet — answered by our community of experienced users.
                </p>
                <div className="flex items-center gap-4">
                  <div>
                    <p className="text-sm font-semibold text-background-50">AcBuy Community</p>
                    <p className="text-xs text-background-50/50">Trusted by 10,000+ users</p>
                  </div>
                </div>
              </div>

              <div className="lg:w-3/5">
                <div className="space-y-3">
                  {faqs.map((faq, idx) => (
                    <div
                      key={idx}
                      className="bg-foreground-900/50 rounded-xl overflow-hidden border border-foreground-800/30"
                    >
                      <button
                        onClick={() => setOpenIndex(openIndex === idx ? null : idx)}
                        className="w-full flex items-center justify-between px-5 py-4 text-left cursor-pointer"
                      >
                        <span className="text-sm font-semibold text-background-50 pr-4">{faq.question}</span>
                        <i
                          className={`ri-arrow-down-s-line text-background-50/60 transition-transform duration-200 flex-shrink-0 ${
                            openIndex === idx ? 'rotate-180' : ''
                          }`}
                        ></i>
                      </button>
                      {openIndex === idx && (
                        <div className="px-5 pb-4">
                          <p className="text-sm text-background-50/70 leading-relaxed">{faq.answer}</p>
                        </div>
                      )}
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}